import * as React from "react";

function locations(substring: string, value: string) {
  const a = [];
  let i = -1;
  // tslint:disable-next-line:no-conditional-assignment
  while ((i = value.indexOf(substring, i + 1)) >= 0) {
    a.push(i);
  }
  return a;
}

function highlightText(name: string, inputStr: string) {
  if (!inputStr || !inputStr.length || !name || !name.length) {
    return "";
  }

  const nameLC = name.toLowerCase();
  const inputLC = inputStr.toLowerCase();

  const indexes = locations(inputLC, nameLC);

  let keyIndex = 0;
  const result = [];
  for (let i = 0; i < indexes.length; i++) {
    const prevEnd = i === 0 ? 0 : indexes[i - 1] + inputLC.length;
    const start = indexes[i];
    const end = start + inputLC.length;

    result.push(
      <React.Fragment key={keyIndex++}>
        {name.slice(prevEnd, start)}
      </React.Fragment>
    );

    result.push(<strong key={keyIndex++}>{name.slice(start, end)}</strong>);
    if (i === indexes.length - 1) {
      result.push(
        <React.Fragment key={keyIndex++}>{name.slice(end)}</React.Fragment>
      );
    }
  }

  return result;
}

export default highlightText;
